var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveMembers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "23px",
    viewBox: "0 0 19 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icActiveMembers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.7487422,10.2 C4.08309911,10.2 2.72025403,8.97437345 2.72,7.47620775 L2.72,6.1235638 C2.72,4.62562655 4.08309911,3.4 5.7487422,3.4 L6.4912578,3.4 C8.15715492,3.4 9.52,4.62562655 9.52,6.1235638 L9.52,7.47620775 C9.52,8.97437345 8.15690089,10.2 6.4912578,10.2 L5.7487422,10.2 Z M9.41465162,12.24 C10.9726431,12.24 12.24,13.6822915 12.24,15.455063 L12.24,20.09832 C12.24,20.6405349 11.8538373,21.08 11.3773873,21.08 L0.86261269,21.08 C0.386162709,21.08 -1.09245946e-13,20.6405349 -1.09245946e-13,20.09832 L-1.09245946e-13,15.455063 C-1.09245946e-13,13.6822915 1.26735695,12.24 2.82487193,12.24 L9.41465162,12.24 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends-&-Favourites",
    transform: "translate(-25.000000, -560.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icActiveMembers",
    transform: "translate(26.200000, 560.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#7CBC47",
    cx: 14.28,
    cy: 2.72,
    r: 2.72
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveMembers);
export default __webpack_public_path__ + "static/media/icActiveMembers.ee401c2304ef3ca6adbe20b554be93ff.svg";
export { ForwardRef as ReactComponent };